import { environment } from "environments/environment";

/**
 * Navigation of customer users, in menu order. An item is shown when the customer has its feature
 * (deviceCondition, userCondition) and the user can open its page: the level the route asks for
 * (app.routing.ts, checked by StartPageService with the guards' rules), so an item never bounces.
 * The first item the user can open is their start page. Built-in roles see what they saw before:
 * every one of them can read these pages, except Mobile whitelist (MainUser and CustomerAdmin),
 * Roles (MainUser and CustomerAdmin) and Activity log (CustomerAdmin).
 */
export const CUSTOMER_NAV_TABS: INavTabItem[] = [
  {
    path: "/dashboard",
    name: "NAV_DASHBOARD",
    fa_icon: "fa-duotone fa-house fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/device",
    name: "NAV_DEVICE_MANAGEMENT",
    fa_icon: "fa-duotone fa-phone-laptop fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/staff",
    name: "STAFF_MEMBERS",
    fa_icon: "fa-duotone fa-user fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/roles",
    name: "ACCESS_ROLES",
    fa_icon: "fa-duotone fa-user-shield fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/teams",
    name: "RECEIVER_TEAMS",
    fa_icon: "fa-duotone fa-users fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/mobile-whitelist",
    name: "MOBILE_WHITELIST",
    fa_icon: "fa-duotone fa-mobile-android fa-fw",
    userCondition: "EmaPhoneWhitelist",
    deviceCondition: true,
  },
  {
    path: "/route",
    name: "ALARM_ROUTES",
    fa_icon: "fa-duotone fa-bells fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/reports",
    name: "NAV_REPORT",
    fa_icon: "fa-duotone fa-list fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/reports/statistics",
    name: "NAV_STATISTICS",
    fa_icon: "fa-duotone fa-chart-bar fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
  {
    path: "/reports/activity",
    name: "NAV_ACTIVITY",
    fa_icon: "fa-duotone fa-monitor-heart-rate fa-fw",
    userCondition: true,
    deviceCondition: "DeviceMovement",
  },
  {
    path: "/anna-perenna",
    name: "AnnaPerenna",
    fa_icon: "fa-light fa-camera fa-fw",
    userCondition: true,
    deviceCondition: "AnnaPerenna",
  },
  {
    path: "/onon",
    name: "OnOn",
    fa_icon: "fa-duotone fa-webcam fa-fw",
    userCondition: true,
    deviceCondition: "OnOn",
  },
  {
    path: "/camera-supervision",
    name: "CameraSupervision",
    fa_icon: "fa-duotone fa-cctv fa-fw",
    userCondition: true,
    deviceCondition: "CameraSupervision",
  },
  {
    path: "/activity-log",
    name: "ACTIVITY_LOG",
    fa_icon: "fa-duotone fa-user-pen fa-fw",
    userCondition: true,
    deviceCondition: true,
  },
];

/** Kept for existing imports: both customer navigations are the same list, filtered by permission */
export const ALL_TABS_NORMAL_USER: INavTabItem[] = CUSTOMER_NAV_TABS;
export const ALL_NAV_TABS_CUSTOMER_ADMIN: INavTabItem[] = CUSTOMER_NAV_TABS;

export const NAV_TABS_ADMIN: INavTabItem[] = [
  {
    path: "/dashboard/admin",
    name: "NAV_DASHBOARD",
    fa_icon: "fa-duotone fa-house fa-fw",
  },
  {
    path: "/system/firmware",
    name: "FIRMWARES",
    fa_icon: "fa-duotone fa-archive fa-fw",
  },
  {
    path: "/system/users",
    name: "USERS",
    fa_icon: "fa-duotone fa-users fa-fw",
  },
  {
    path: "/system/company-management",
    name: "COMPANY_MANAGEMENT",
    fa_icon: "fa-duotone fa-building fa-fw",
  },
  {
    path: "/system/company-groups",
    name: "COMPANY_GROUPS",
    fa_icon: "fa-duotone fa-buildings fa-fw",
  },
  {
    path: "/alarm-reasons",
    name: "ALARM_REASONS",
    fa_icon: "fa-duotone fa-bell-on fa-fw",
  },
  {
    path: environment.internalPortalUrl,
    name: "Internal portal",
    fa_icon: "fa-duotone fa-solid fa-gears fa-fw",
    userCondition: true,
    deviceCondition: "",
  }, 
  {
    path: environment.keysyncUrl,
    name: "Keysync",
    fa_icon: "fa-duotone fa-solid fa-lock fa-fw",
    userCondition: true,
    deviceCondition: "",
  }, 
  {
    path: environment.ononCoreUrl,
    name: "OnOn-Core",
    fa_icon: "fa-duotone fa-webcam fa-fw",
    userCondition: true,
    deviceCondition: "",
  },
];

export const NAV_TABS_LANDING_PAGE: INavTabItem[] = [
  {
    path: "/landing-page/dashboard",
    name: "NAV_DASHBOARD",
    fa_icon: "fa-duotone fa-house fa-fw",
  },
  {
    path: "/landing-page/residents",
    name: "RESIDENTS",
    fa_icon: "fa-duotone fa-user fa-fw",
  },
  {
    path: "/landing-page/devices",
    name: "DEVICES",
    fa_icon: "fa-duotone fa-phone-laptop fa-fw",
  },
  {
    path: "/landing-page/staff",
    name: "STAFF",
    fa_icon: "fa-duotone fa-user fa-fw",
  },
];

export interface INavTabItem {
  path: string;
  name: string;
  fa_icon: string;
  userCondition?: boolean | string;
  deviceCondition?: boolean | string;
}
